import { gate } from 'hub-http/gates';
import { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
export const SALES_DOCUMENTS_SALES_ACCESS_GATE = gate('DealCollaboration:SalesDocumentsSalesAccess');
export const useHasDocumentsPaidAccessScope = () => {
  const auth = useContext(AuthContext);
  return Boolean(auth && auth.user.scopes.includes('documents-paid-access'));
};
export const useHasDocumentsReadAccessScope = () => {
  const auth = useContext(AuthContext);
  return Boolean(auth && auth.user.scopes.includes('documents-read-access'));
};
export const useIsUngatedForDocumentsSalesAccess = () => {
  const auth = useContext(AuthContext);
  return Boolean(auth && auth.gates.includes(SALES_DOCUMENTS_SALES_ACCESS_GATE));
};